import { getAccessToken } from '@privy-io/react-auth';
import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL as string;

export const $api = axios.create({
  withCredentials: true,
  baseURL: API_URL,
});

$api.interceptors.request.use(
  async (config) => {
    const token = await getAccessToken();

    if (!token) {
      return Promise.reject(new Error('No access token available'));
    }

    // Uncomment this line if you want to use extension flow
    // config.headers.Authorization = `Bearer ${token}`; 
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
